const CustomSwitch = ({ checked, onChange }) => {
    return (
        <label className="Permission_switch">
            <input type="checkbox" checked={checked} onChange={onChange} />
            <span className="slider"></span>
        </label>
    );
};


export default CustomSwitch